import TruckBadge from './TruckBadge';

export default TruckBadge;
